module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-7c2701ba51036fcacf3e6c7b3cf4c3b9.png";